module.exports = __webpack_public_path__ + "static/media/20210409_195044_349_IMG_0089.51ffd5e0.jpg";